export default function LoadingScreen() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background-50">
      <div className="flex flex-col items-center gap-4">
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100">
          <i className="ri-loader-4-line animate-spin text-2xl text-primary-600"></i>
        </span>
        <p className="text-sm text-foreground-600">불러오는 중이에요...</p>
      </div>
    </div>
  );
}